<template>
  <div>
    <div class="verification-tabs mb-3">
      <button
        type="button"
        class="verification-tab-item"
        :class="{ active: activeTab === TAB.KYC }"
        @click="activeTab = TAB.KYC"
      >
        KYC Verification
      </button>
      <button
        v-if="$can('list_aml')"
        type="button"
        class="verification-tab-item"
        :class="{ active: activeTab === TAB.AML }"
        @click="activeTab = TAB.AML"
      >
        AML Verification
      </button>
    </div>

    <kyc-verification-tab 
      :partner-options="partnerOptions" 
      v-show="activeTab === TAB.KYC">
    </kyc-verification-tab>

    <aml-verification-tab
      v-if="$can('list_aml')"
      :partner-options="partnerOptions"
      v-show="activeTab === TAB.AML"
    ></aml-verification-tab>
  </div>
</template>

<script>
import KycVerificationTab from "./components/KycVerificationTab.vue";
import AmlVerificationTab from "./components/AmlVerificationTab.vue";

export default {
  name: "VerifyTable",
  components: {
    KycVerificationTab,
    AmlVerificationTab,
  },
  data() {
    return {
      TAB: {
        KYC: "kyc",
        AML: "aml",
      },
      activeTab: "kyc",
      partnerOptions: [{ value: "", text: "Choose Partner" }],
      errors: {
        code: "",
        message: "",
        status: "",
      },
    };
  },
  created() {
    this.$http
      .get(`partner-list`)
      .then((response) => {
        const newPartner = response.data.map((item) => ({ value: item.id, text: item.name }));
        this.partnerOptions = [...this.partnerOptions, ...newPartner];
      })
      .catch((error) => {
        this.handleLoadError(error);
      });
  },
  methods: {
    handleLoadError(error) {
      this.errors.code = error.response.data.meta.code;
      this.errors.message = error.response.data.meta.message;
      this.errors.status = error.response.data.meta.code;
      if (this.errors.code == 401) this.$router.push("/login");
      else if (this.errors.code == 403) this.$router.push("/403");
      else if (this.errors.code == 500) this.$router.push("/500");
      else {
        this.$swal.fire(
          "Error!",
          this.errors.message || "Something went wrong. Please try again later.",
          "error"
        );
      }
    },
  },
};
</script>

<style>
.verification-tabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d8dbe0;
}

.verification-tab-item {
  border: none;
  background: transparent;
  padding: 10px 20px;
  font-weight: 600;
  color: #73818f;
  border-bottom: 2px solid transparent;
}

.verification-tab-item.active {
  color: #20a8d8;
  border-bottom-color: #20a8d8;
}

.verification-tab-item:focus {
  outline: none;
}
</style>